import React from 'react';
// import "../styles/notfound1.css";
import { Link } from 'react-router-dom';
function NotFound() {
  return (
    <div className="flex flex-col justify-center items-center h-screen bg-gray-100 text-center space-y-3 ">
      <h1 className="text-6xl font-bold text-red-600 animate-pulse transition-all duration-200 ease-in-out">404</h1>
      <h2 className="text-4xl">Page Not Found</h2>
      <p className="text-lg text-gray-700">The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
      <Link to="/" className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700 transition-colors duration-300">Go Home</Link>
    </div>
    // <div class='error-page-container flex justify-center items-center h-screen'>
    //   <a href="https://codepen.io/uiswarup/full/vYPxywO" target="_blank">
    //     <header class="top-header"></header>

    //     <div class="stars">
    //       <div class="starsec"></div>
    //       <div class="starthird"></div>
    //       <div class="starfourth"></div>
    //       <div class="starfifth"></div>
    //     </div>

    //     <div class="lamp__wrap">
    //       <div class="lamp">
    //         <div class="cable"></div>
    //         <div class="cover"></div>
    //         <div class="in-cover">
    //           <div class="bulb"></div>
    //         </div>
    //         <div class="light"></div>
    //       </div>
    //     </div>

    //     <section class="error">
    //       <div class="error__content">
    //         <div class="error__message message">
    //           <h1 class="message__title">Page Not Found</h1>
    //           <p class="message__text">We're sorry, the page you were looking for isn't found here. The link you followed may either be broken or no longer exists. Please try again, or take a look at our.</p>
    //         </div>
    //         <div class="error__nav e-nav">
    //           <a href="http://www.thedresscounter.com" target="_blank" class="e-nav__link">Go to Homepage</a>
    //         </div>
    //       </div>
    //     </section>
    //   </a>
    // </div>


  );
}
export default NotFound;